import { loginReq as request } from "@/axios/apiRequest";
import qs from "qs";

// 用户名登录
export const loginByUsername = (username, password, code, randomStr) => {
  let grant_type = "password";
  let dataObj = qs.stringify({
    username: username,
    password: password,
    device_type: 3,
  });

  return request({
    url: "/x-api/auth/oauth/token",
    headers: {
      isToken: false,
      "TENANT-ID": "",
      Authorization: "Basic c2FhczpzYWFz",
    },
    method: "post",
    params: { randomStr, code, grant_type },
    data: dataObj,
  });
};

export const refreshToken = (refresh_token) => {
  const grant_type = "refresh_token";
  return request({
    url: "/x-api/auth/oauth/token",
    headers: {
      isToken: false,
      "TENANT-ID": "",
      Authorization: "Basic c2FhczpzYWFz",
    },
    method: "post",
    params: { refresh_token, grant_type, scope: "server" },
  });
};

export const loginByMobile = (mobile, code) => {
  const grant_type = "mobile";
  return request({
    url: "/x-api/auth/mobile/token/sms",
    headers: {
      isToken: false,
      "TENANT-ID": "",
      Authorization: "Basic c2FhczpzYWFz",
    },
    method: "post",
    params: { mobile: "SMS@" + mobile, code: code, grant_type, device_type: 3 },
  });
};

// 通过token拿取个人信息
export function getUserInfoByToken() {
  return request({
    url: "/x-api/admin/loginUser/info",
    method: "get",
  });
}

export const getUserInfo = (username) => {
  return request({
    url: `/x-api/admin/user/info/${username}`,
    method: "get",
  });
};

export const logout = () => {
  return request({
    url: "/x-api/auth/token/logout",
    method: "delete",
  });
};

// 手机验证码
export function getPhoneCode(param) {
  return request({
    url: "/x-api/admin/mobile/smsCodeSend/V2",
    method: "post",
    data: {
      param
    },
  });
}

// 查询多租户
export function finduserTenantByUserId(userId) {
  return request({
    url: "/x-api/admin/tenant/findUserTenantByUserId",
    method: "get",
    params: {
      deviceType: 3,
      userId,
    },
  });
}

// 选择租户
export function chooseTenantToLogin(data) {
  return request({
    url: "/x-api/admin/user/refreshLoginUser",
    method: "post",
    data: {
      ...data,
      deviceType: 3,
    },
  });
}


